import { InnerBlocks } from '@wordpress/block-editor';
import {
	useBlockProps
} from '@wordpress/block-editor';
import classnames from 'classnames';

const Save = ({attributes}) => {

    let loopClasses = classnames(
           'wp-block-vayu-blocks-advance-query-loop',
           attributes.uniqueId,
           {
           'th-hide-desktop': attributes.advResponsive?.Desktop === true,
    'th-hide-tablet': attributes.advResponsive?.Tablet === true,
    'th-hide-mobile': attributes.advResponsive?.Mobile === true,
          });
    
    const blockProps = useBlockProps.save({
        id: attributes.uniqueId,
        className:loopClasses,
    });

    return (
        <div { ...blockProps } >
            <InnerBlocks.Content />
        </div>
    );

};

export default Save;